import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Button,
  Container,
  //   makeStyles,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Chip,
  CircularProgress
} from '@material-ui/core';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#202340',
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

function ProfileDataTable({ tableHead, tableData, className, loading }) {
  return (
    <TableContainer className={className.datatable} component={Paper}>
      <Table className={className.table}>
        <TableHead>
          <TableRow>
            {tableHead.map((item, index) => (
              <StyledTableCell key={index} align="center">
                {item.title}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        {!loading ? (
          <TableBody>
            {tableData.map((item, index) => (
              <StyledTableRow key={index}>
                <TableCell> {index + 1} </TableCell>
                <TableCell align="center"> {item.fullname} </TableCell>
                <TableCell align="center"> {item.username} </TableCell>
                <TableCell align="center"> {item.email} </TableCell>
                <TableCell align="center"> {item.phone} </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        ) : (
          <TableBody>
            <StyledTableRow>
              <TableCell>
                <CircularProgress size="1rem" />
              </TableCell>
            </StyledTableRow>
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
}

export default ProfileDataTable;
